import React from "react";
import "./style.scss";

import { TimelineItemWithIcon } from "../../../components";

import { RiStore2Line } from "react-icons/ri";

const Index = ({ product }) => (
  <>
    <div className={"wizard-wrapper timeline d-flex flex-row"}>
      <div className={"flex-row"}>
        {product?.StatusList.map((item, index) => (
          <div key={index}>
            <TimelineItemWithIcon
              itemNo={1}
              userType={"user"}
              formName={item.StatusTitle}
              done={true}
              status={item.Status === "Done" ? "done" : item.Status}
              isFocusTab={false}
              formIcon={<RiStore2Line />}
              step={item.Status}
            />
          </div>
        ))}
      </div>
    </div>
  </>
);
export default Index;
